import { render, staticRenderFns } from "./AddonClarity.vue?vue&type=template&id=13e53a09&scoped=true&"
import script from "./AddonClarity.vue?vue&type=script&lang=js&"
export * from "./AddonClarity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e53a09",
  null
  
)

export default component.exports